import React, {Fragment} from 'react';
import {Modal as BootstrapModal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import PrimaryButton from "../../Styled/Buttons/PrimaryButton.jsx";
import SecondaryButton from "../../Styled/Buttons/SecondaryButton.jsx";
import Modal from '../Modal.jsx'
class AppointmentTookPlaceConfirmModal extends Modal {
  constructor(props) {
    super(props);

    this.state = {
      updateText: false,
    };

    this.close = () => this.props.closeModal();
  }

  render() {
    const modalProps = {
      className: 'modal-mission-example'
    };

    modalProps.toggle = this.close;

    return (
      <BootstrapModal {...modalProps} isOpen={this.props.isOpen} size="lg">
        <ModalHeader {...modalProps}> Exemple </ModalHeader>
        <ModalBody>
          <Fragment>
            La date de votre rendez-vous visio n'est pas encore passée, vous confirmez vouloir passer à l'étape suivante ?
          </Fragment>
        </ModalBody>
        <ModalFooter>
          <PrimaryButton onClick={this.props.onAppointmentTookPlaceConfirm}>Oui</PrimaryButton>
          <SecondaryButton onClick={this.close}>Non</SecondaryButton>
        </ModalFooter>
      </BootstrapModal>
    );
  }
}
export default AppointmentTookPlaceConfirmModal


